import { Frame as CoreFrame } from '@studiometa/ui';
import { FrameSelect } from './FrameSelect.js';

/**
 * Frame component
 */
export class Frame extends CoreFrame {
  static config = {
    ...CoreFrame.config,
    components: {
      ...CoreFrame.config.components,
      FrameSelect,
    },
  };

  /**
   * Fetch new content on frame-trigger.
   * @param {object} props
   * @param {Array}  props.args
   * @param {URL}  props.args.0
   * @param {FrameRequestInit}  props.args.1
   */
  onFrameSelectFrameTrigger({ args: [url, requestInit] }) {
    this.fetch(url, requestInit);
  }
}
